module.exports = __webpack_public_path__ + "static/media/image_Ellipse2_ICON.8f672c36.svg";